// Copyright 2019 The Chromium Authors
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.

import {css} from 'lit-element';

export const SHARED_STYLES = css`
  .small {
    font-size: 12px;
  }
  .error {
    color: red;
    font-size: 12px;
  }
`;
